import { useConfigurationOptionsContext } from "app/providers/DoorOptionsProvider";
import InstallmentOptionControls from "features/option-controls/installment-option-controls";
import OptionTemplate from "shared/ui/option-template";
import { OptionModalState } from "widgets/configurator/option-modal";
import { MobileSelfAssemblyPage } from "./MobileSelfAssemblyPage";
import { DOORS_WITH_ENABLED_INSTALLMENT_TOGGLE } from "widgets/configurator/door-options/SelfAssemblyBlock";
import { DELIVERY_PRICES } from "shared/config/pricing";

type ExtraOptionsBlockType = {
  setOptionModalState: (state: OptionModalState) => void;
  setSelfAssemblyPageOpen: (open: boolean) => void;
};

export const MobileSelfAssemblyBlock = ({
  setOptionModalState,
  setSelfAssemblyPageOpen,
}: ExtraOptionsBlockType) => {
  const { selfAssembleDoorData, selectedDoor } =
    useConfigurationOptionsContext();

  if (!selectedDoor) return <></>;
  return (
    <>
      {DOORS_WITH_ENABLED_INSTALLMENT_TOGGLE.includes(selectedDoor.code) && (
        <OptionTemplate
          title="Montagewijze"
          description="Wil je het inmeten en monteren door GewoonGers laten verzorgen of ga je zelf aan de slag? Maak je keuze hier."
          onShowInfoClick={() =>
            setOptionModalState({
              isOpen: true,
              heading: "Montagewijze",
              description: `Kies je voor monteren door GewoonGers? Dan is de getoonde prijs altijd inclusief inmeetservice, transport en montage. Kies je ervoor om zelf in te meten en te monteren? Dan wordt er een korting berekend over de totaalprijs en betaal je €${DELIVERY_PRICES.SELF_ASSEMBLY},- bezorgkosten.`,
            })
          }
          testId="installment-option"
          borderBottom={false}
        >
          <InstallmentOptionControls
            setSelfAssemblyPageOpen={setSelfAssemblyPageOpen}
          />
        </OptionTemplate>
      )}
    </>
  );
};
